import React from 'react';
import '../styles/Team.css';
import Navbar from './Navbar';
import Footer from './Footer';
import { useEffect } from 'react';

function Team() {

  useEffect(() => {
      document.title = "Our Team - Legal Trails";  // Set Page Title
    }, []);


  return (
    <>
      <Navbar />
      <div className="team ">
      <div className="image-container">
  <img
    src="our-team.jpg"
    alt="Our Team"
  />
</div>
<br></br>

        <div className="container">


          
          <div className="row">
          <h4 className="text-center1">
            <p>
            Meet our team of excellent lawyers and chartered accountants (CAs) who work collaboratively to provide you with comprehensive legal and financial solutions. With a deep commitment to justice and professionalism, our experts are dedicated to understanding your needs and delivering tailored advice and representation. Whether it's navigating complex legal challenges or offering precise financial insights, our team is here to ensure you receive the support and guidance you deserve.
            </p>
          </h4>
            {/* Team Member 1 */}
            <div className="col-md-6 d-flex mb-4">
              <div className="team-member">
                <div className="team-image">
                  <img
                    src="/Sonal.jpg"
                    alt="Sonal Khattri"
                    className="img-fluid rectangle"
                  />
                </div>
                <div className="team-info">
                  <h3>Sonal Khattri</h3>
                  {/* <p className="font-weight-bold">B.Com, LL.B (Gold Medalist) 🎖️, LL.M</p> */}
                  <p>Sonal Khattri is a gold medalist in LL.B, boasting extensive experience in handling complex matrimonial and divorce matters. Her expertise also spans consumer and civil cases, showcasing her versatility and proficiency in navigating diverse legal realms. Notably, she possesses specialized knowledge in the Prevention of Sexual Harassment (POSH) arena, serving as an external member of the Internal Complaints Committee for her esteemed clients. Additionally, she has experience in Intellectual Property law, specifically in Trademark matters, providing comprehensive guidance on brand protection and registration. With extensive expertise in navigating complex legal frameworks, she provides pragmatic, solution-driven legal strategies tailored to meet the diverse needs of her clients. Her unique blend of academic excellence, practical experience, and commitment to fostering a safe and equitable work environment makes her an invaluable asset to those seeking expert legal counsel.</p>
                </div>
              </div>
            </div>
            {/* Team Member 2 */}
            <div className="col-md-6 d-flex mb-4">
              <div className="team-member">
                <div className="team-image">
                  <img
                    src="/Himanshu.jpg"
                    alt="Himanshu Gupta"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info">
                  <h3>Himanshu Gupta</h3>
                  {/* <p className="font-weight-bold">B.Com, LL.B</p> */}
                  <p>Himanshu Gupta is a seasoned legal professional specializing in Commercial, Corporate, and Labor Law, offering strategic legal counsel and robust representation to businesses and individuals alike. With a strong grasp of regulatory compliance, contract law, dispute resolution, and employment relations, Himanshu has successfully advised corporations, startups, and entrepreneurs on legal matters related to business operations, governance, contractual disputes, and labor law compliance. Beyond advisory and transactional work, Himanshu is a skilled litigator, representing clients before courts, tribunals, and regulatory authorities in matters related to corporate disputes, employment conflicts, commercial litigation, and contractual enforcement. He is committed to upholding the highest standards of professionalism, ensuring proactive legal risk management, compliance assurance, and dispute resolution for his clients.</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 d-flex mb-4">
              <div className="team-member">
                <div className="team-image">
                  <img
                    src="/Ishpreet.jpg"
                    alt="Anshul"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info">
                  <h3>Ishpreet Singh</h3>
                  {/* <p className="font-weight-bold">B.Com, LL.B</p> */}
                  <p>
                  Ishpreet Singh is a highly respected and versatile lawyer, renowned for his exceptional expertise and comprehensive practice that spans a wide range of legal disciplines. With a strong foundation in Civil Litigation, Arbitration, Alternate Dispute Resolution, Contractual Disputes, and Property and Real Estate Matters, he offers clients a unique blend of technical knowledge, strategic insight, and practical experience. Leveraging his vast expertise and in-depth knowledge, he delivers meticulous guidance, strategic counsel, and effective representation to clients, ensuring they achieve optimal outcomes in complex legal disputes. His ability to navigate intricate legal issues, combined with his exceptional advocacy skills and commitment to results-driven solutions, makes him a trusted advisor and advocate for clients seeking expert representation in a wide range of legal matters.
                  </p>
                </div>
              </div>
            </div>


            <div className="col-md-6 d-flex mb-4">
              <div className="team-member">
                <div className="team-image">
                  <img
                    src="/Prabhat.jpg"
                    alt="CA"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info">
                  <h3>Prabhat Kumar</h3>
                  {/* <p className="font-weight-bold">B.Com, M.Com, ACA</p> */}
                  <p>
                  Prabhat Kumar is an Advocate-on-Record with extensive expertise in Indian law, specializing in Constitutional, Civil, Criminal, Corporate, Consumer, and Matrimonial Law. With a proven track record of success, he adeptly navigates complex legal matters, offering strategic counsel, precise legal drafting, and in-depth research to provide tailored solutions that align with each client’s unique needs. With a deep understanding of judicial procedures and statutory frameworks, he has successfully represented clients before various courts and tribunals, including the Hon’ble Supreme Court of India and High Courts. His ability to analyze intricate legal issues, craft persuasive arguments, and devise effective litigation strategies has earned him a reputation for excellence in advocacy.
                  </p>
                </div>
              </div>
            </div>


            <div className="col-md-6 d-flex mb-4">
              <div className="team-member">
                <div className="team-image">
                  <img
                    src="/Vikram.jpg"
                    alt="CA"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info">
                  <h3>Vikram Singh</h3>
                  {/* <p className="font-weight-bold">B.Com, M.Com, ACA</p> */}
                  <p>
                  Vikram Singh is a seasoned litigator with 17 years of expertise in navigating complex civil and commercial disputes, providing strategic counsel and representation to clients across a wide range of legal matters. With a strong track record of success, Vikram Singh offers clients expert guidance on dispute resolution, litigation strategy, and negotiation tactics. His extensive experience spans various industries and jurisdictions, enabling him to deliver tailored solutions that address the unique needs and goals of each client.
                  </p>
                  
                </div>
              </div>
            </div>


            {/* Team Member 3 */}
            <div className="col-md-6 d-flex mb-4">
              <div className="team-member">
                <div className="team-image">
                  <img
                    src="/Himanshu Mann.jpg"
                    alt="Himanshu Mann"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info">
                  <h3>Himanshu Mann</h3>
                  {/* <p className="font-weight-bold">B.Com, LL.B</p> */}
                  <p>
                  Himanshu Mann is a seasoned expert in building compliance and having experties in IT Law and arbitration, with a proven track record of successfully navigating complex regulatory frameworks. As a trusted liaison, he ensures facilitating seamless communication and ensuring timely compliance solutions for clients. His dedication to delivering exceptional legal services, coupled with his passion for achieving successful outcomes, has earned him a reputation as a leading lawyer in his field.
                  </p>
                </div>
              </div>
            </div>

            {/* Team Member 4 */}
            <div className="col-md-6 d-flex mb-4">
              <div className="team-member">
                <div className="team-image">
                  <img
                    src="/Anshul .jpg"
                    alt="Anshul"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info">
                  <h3>Anshul Kumar</h3>
                  {/* <p className="font-weight-bold">B.Com, LL.B</p> */}
                  <p>
                  Anshul Kumar is a seasoned attorney with expertise in criminal law and statutory legislation. He provides astute representation and counsel to clients navigating complex criminal cases and statutory compliance matters, leveraging his in-depth knowledge and experience to deliver effective solutions.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 d-flex mb-4">
              <div className="team-member">
                <div className="team-image">
                  <img
                    src="/Sarthak.png"
                    alt="Sarthak"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info">
                  <h3>Sarthak Sharma</h3>
                  {/* <p className="font-weight-bold">B.Com, LL.B</p> */}
                  <p>
                  Sarthak Sharma is a skilled criminal lawyer and employment law specialist, providing expert representation and counsel to clients facing criminal charges and workplace disputes. His practice spans criminal defense, employment litigation, and labor law, ensuring comprehensive support for individuals and organizations navigating complex legal challenges.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 d-flex mb-4">
              <div className="team-member">
                <div className="team-image">
                  <img
                    src="/Paras .jpg"
                    alt="Paras"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info">
                  <h3>Paras Thakur</h3>
                  {/* <p className="font-weight-bold">B.Com, LL.B</p> */}
                  <p>
                  Paras Thakur is a seasoned expert in political compliance and strategy, serving as a trusted advisor to politicians, parties, and organizations. He provides guidance on campaign strategy, policy decisions, and regulatory compliance, ensuring his clients navigate the complexities of politics with confidence and integrity. His expertise enables politicians and organizations to make informed decisions, avoid potential pitfalls, and maintain a strong reputation.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 d-flex mb-4">
              <div className="team-member">
                <div className="team-image">
                  <img
                    src="/Abhishek CA.jpg"
                    alt="CA"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info">
                  <h3>CA Abhishek Gupta</h3>
                  {/* <p className="font-weight-bold">B.Com, M.Com, ACA</p> */}
                  <p>
                  Abhishek Gupta is an experienced Chartered Accountant with a strong expertise in business finance and strategy, internal audit, taxation, and statutory audit. Additionally, he possesses extensive experience in mergers and acquisitions, providing comprehensive guidance on deal structuring, due diligence, and post-merger integration. His unique blend of technical expertise and strategic acumen enables him to deliver value-added services to clients across a wide range of industries.
                  </p>
                </div>
              </div>
            </div>



          </div>
      </div>
      </div>
      
      <Footer />
    </>
  );
}

export default Team;
